<template>
    <div>
        <veui-drawer
            overlay-class="caseDeatil"
            title="问答语料"
            :open.sync="open"
            :before-close="hideDetail"
        >
            <div id="qa-detail-html" class="content">
                <div class="item-label">问题描述</div>
                <div class="item-value">{{ qaInfo.title }}</div>
                <div class="item-label">回答内容</div>
                <!--bca-disable-->
                <div class="item-value" v-html="qaInfo.reply_content"></div>
                <!--bca-enable-->
            </div>
            <template #foot>
                <div class="edit-btn" @click="edit">编辑</div>
            </template>
        </veui-drawer>
    </div>
</template>

<script>
// 问答详情
import {Drawer} from 'veui';
export default {
    name: 'caseDetail',
    components: {
        'veui-drawer': Drawer
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        qaInfo: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        edit() {
            this.hideDetail();
            this.$emit('showQaEdit', {qaInfo: this.qaInfo});
        },
        hideDetail() {
            this.$emit('hideDetail');
        }
    }
};
</script>

<style lang='less' scoped>
.caseDeatil {
    /deep/.veui-dialog-content {
        padding-bottom: 40px;
    }

    /deep/.veui-dialog-content-head {
        padding-top: 40px;
        padding-left: 40px;
        padding-right: 40px;
    }

    /deep/.veui-dialog-content-body {
        padding-left: 40px;
        padding-right: 40px;
    }

    /deep/.veui-dialog-content-foot {
        border-top: 1px solid rgba(246, 248, 249, 1);
        padding-top: 30px;
        padding-left: 40px;

        .edit-btn {
            width: 96px;
            height: 40px;
            background: #05f;
            border-radius: 5px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #fff;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
        }
    }

    .content {
        margin-top: 18px;
    }

    .item-label {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #848691;
        line-height: 16px;

        &:not(:first-child) {
            margin-top: 23px;
        }
    }

    .item-value {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #1e1f24;
        line-height: 28px;
        margin-top: 6px;
        text-align: justify;
    }
}
</style>
<style lang="less">
#qa-detail-html {
    .ql-align-right {
        text-align: right;
    }

    .ql-align-center {
        text-align: center;
    }

    blockquote {
        border-left: 4px solid #ccc;
        margin-bottom: 5px;
        margin-top: 5px;
        padding-left: 16px;
    }

    li {
        display: list-item;
        text-align: -webkit-match-parent;
        unicode-bidi: isolate;
    }

    ul li {
        list-style-type: disc; /* 设置列表项标记的类型为实心圆点，这是ul的默认值 */
    }

    ol li {
        list-style-type: decimal;
    }

    ul,
    ol,
    ul li,
    ol li {
        margin-left: 1.5em; /* 通常浏览器会给嵌套的列表一个左边距 */
    }

    img {
        height: 40%;
        width: 40%;
    }
}
</style>
